import React, { Component, createRef } from 'react';
import { PaddedBlock } from './components/atoms';
import {
  HeaderView,
  FooterView,
  ContactUsView,
  GetInTouchView,
  ContentRevisionCycleView,
  DocBrowserWebPortal,
  IFlyThereVideoView,
  TaggisView,
  XRAviationView,
  ARCDeskPortalView,
  IreformAppView,
  IReFormVideoView,
} from './components/views';

class SolutionsPage extends Component {

  cycleIo: IntersectionObserver | undefined;

  cycleRef = createRef<HTMLElement>();

  componentDidMount () {
      this.setupIntersectionObserver();
      window.scrollTo(0, 0);
  }

  componentWillUnmount () {
      if (this.cycleIo) this.cycleIo.disconnect();
  }

  animateCycle(entries: IntersectionObserverEntry[]) {
      const [{ intersectionRatio, target }] = entries;
      if (intersectionRatio > 0.4) {
          target.classList.add('active');
      }
  }

  setupIntersectionObserver = async () => {
      this.cycleIo = new IntersectionObserver(this.animateCycle.bind(this), { threshold: 0.5 });
      if (this.cycleRef.current) this.cycleIo.observe(this.cycleRef.current);
  }

  render() {
    return (
      <main>
        <HeaderView opaque={true} />
        <PaddedBlock padding={60} />
        <DocBrowserWebPortal />
        <IFlyThereVideoView />
        <ARCDeskPortalView />
        <XRAviationView />
        <IreformAppView />
        <TaggisView />
        <ContentRevisionCycleView forwardedRef={this.cycleRef}/>
        <GetInTouchView />
        <ContactUsView />
        <FooterView />
      </main>
    );
  }
}

export default SolutionsPage;
